const scrollToElement = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
        behavior: "smooth",
    });
};

export default scrollToElement